const base64 = {
  encode: (str) => {
    if (typeof window === "undefined") {
      return Buffer.from(str).toString("base64");
    } else {
      return btoa(str);
    }
  },
  decode: (str) => {
    if (typeof window === "undefined") {
      return Buffer.from(str, "base64").toString("utf8");
    } else {
      return atob(str);
    }
  },
};

export default base64;

export function getBase64Size(base64) {
  const str = base64.split(",")[1].split("=")[0];
  const strLength = str.length;
  const size = Math.ceil(strLength - (strLength / 8) * 2);
  // 单位为m
  return +(size / 1024 / 1024).toFixed(2);
}
